import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.move-credit-card-items.presenters.MoveCreditCardItemsPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: '{count} item(s) have been moved to the card {name}',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  // Exact Angular parity string (BHV-024).
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Oh-oh. Please try again.',
  },
  // Exact Angular parity strings (BHV-024).
  noTargetTitle: {
    id: `${scope}.noTargetTitle`,
    defaultMessage: 'No credit card selected',
  },
  noTargetMessage: {
    id: `${scope}.noTargetMessage`,
    defaultMessage: 'Please select a credit card from the dropdown.',
  },
})
